import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { RegistrationApi, type RegisterCompleteRequest } from '@shared/api';

const registerCompleteEffect = createEffect((request: RegisterCompleteRequest) => RegistrationApi.registerComplete(request));
const clearEvent = createEvent();

const $dataStore = createStore<boolean>(false)
  .on(registerCompleteEffect.done, (_, data) => data.result.success)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(registerCompleteEffect.pending, (_, data) => data)
  .on(registerCompleteEffect.fail, () => false)
  .on(registerCompleteEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(registerCompleteEffect, () => null)
  .on(
    registerCompleteEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while Registering. Please try again.').message,
  )
  .on(registerCompleteEffect.done, () => null)
  .reset(clearEvent);

export const $registerCompleteStore = {
  events: {
    registerComplete: registerCompleteEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
